import { render, staticRenderFns } from "./ContractStats.vue?vue&type=template&id=1f9890d6&scoped=true&"
import script from "./ContractStats.vue?vue&type=script&lang=js&"
export * from "./ContractStats.vue?vue&type=script&lang=js&"
import style0 from "./ContractStats.vue?vue&type=style&index=0&id=1f9890d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9890d6",
  null
  
)

export default component.exports